type MatchType = {
  team_two_game_one_score: number;
  team_two_game_two_score: number;
  team_two_game_three_score: number;
  team_two_game_four_score: number;
  team_two_game_five_score: number;
  is_consumed_by_referee_app: boolean;
  match_status: number;
  match_completed_type: number;
  team_winner_uuid: string;
  team_one_uuid: string;
  score_format_game_best_out_of: number;
};

interface ListResultsProps {
  match: MatchType;
  team: 1 | 2;
}

const ListResults = ({ match, team }: ListResultsProps) => {
  const games = ['one', 'two', 'three', 'four', 'five'];
  const teamPrefix = team === 1 ? 'team_one' : 'team_two';
  const teamPrefix2 = team === 1 ? 'team_two' : 'team_one';
  const isRefApp = match.is_consumed_by_referee_app;
  const matchStaus = match.match_status === 4 ? true : false;
  const maxNoOfGames = match ? match.score_format_game_best_out_of : 1;

  function countGamesPlayed(match: MatchType) {
    let gamesPlayed = 0;
    if (match?.match_status === 2) {
      for (const game of games) {
        const scoreTeamOneKey = `team_one_game_${game}_score` as keyof MatchType;
        const scoreTeamTwoKey = `team_two_game_${game}_score` as keyof MatchType;

        const scoreTeamOne = match[scoreTeamOneKey];
        const scoreTeamTwo = match[scoreTeamTwoKey];

        if (typeof scoreTeamOne === 'number' && typeof scoreTeamTwo === 'number') {
          if (scoreTeamOne > 0 || scoreTeamTwo > 0) {
            gamesPlayed++;
          }
        }
      }

      return gamesPlayed === 0 ? maxNoOfGames : gamesPlayed;
    } else {
      return maxNoOfGames;
    }
  }

  const gamesPlayed = countGamesPlayed(match);

  return (
    <>
      {match?.match_completed_type === 6 ? (
        <div className={`flex items-center justify-center py-2 pr-4`}>Canceled</div>
      ) : (
        <div className='flex items-center'>
          {games.map((game, index) => {
            const isGamePlayed = index < gamesPlayed;

            const scoreTeamOne = `team_one_game_${game}_score` as keyof MatchType;
            const scoreTeamTwo = `team_two_game_${game}_score` as keyof MatchType;
            const isFinishedKey = `game_${game}_end_date` as keyof MatchType;
            const isFinished = isRefApp ? matchStaus || !!match[isFinishedKey] : matchStaus;
            const scoreKey = `${teamPrefix}_game_${game}_score` as keyof MatchType;
            const scoreKey2 = `${teamPrefix2}_game_${game}_score` as keyof MatchType;
            const gameStatus = `game_${game}_status` as keyof MatchType;
            const gamesStatusVal = match ? match[gameStatus] : 0;

            let winnerKey;
            if (match[scoreTeamOne] === 0 && match[scoreTeamTwo] === 0) {
              winnerKey = null;
              if (match?.team_winner_uuid && match.team_winner_uuid !== '') {
                winnerKey = match.team_winner_uuid === match.team_one_uuid ? 1 : 2;
              }
            } else {
              winnerKey = match[scoreTeamOne] > match[scoreTeamTwo] ? 1 : 2;
            }

            const bgColor =
              winnerKey === team && isFinished
                ? 'bg-green-100 text-green-700'
                : 'bg-white text-gray-400';

            let scoreDisplay = isGamePlayed ? match[scoreKey] : 0;

            let scoreSymbol = '';

            if (scoreDisplay === 0 && match[scoreKey2] === 0) scoreDisplay = '-';

            if (team === 1) {
              scoreSymbol =
                gamesStatusVal === '4'
                  ? 'WD'
                  : gamesStatusVal === '2'
                    ? 'FF'
                    : gamesStatusVal === '3'
                      ? 'RET'
                      : '';
            } else {
              scoreSymbol =
                gamesStatusVal === '9'
                  ? 'WD'
                  : gamesStatusVal === '7'
                    ? 'FF'
                    : gamesStatusVal === '8'
                      ? 'RET'
                      : '';
            }

            return (
              <div key={`game-${index}}`} className='h-full'>
                {isGamePlayed ? (
                  <div
                    className={`${bgColor} relative flex h-full w-10 flex-col items-center justify-center border-l p-3 font-semibold`}
                  >
                    <span>{scoreDisplay}</span>
                    <span className='absolute bottom-0 text-xs'>{scoreSymbol}</span>
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default ListResults;
